import React from 'react';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">About Alium Software</h2>
            <p className="about-description">
              Like the Allium flower that blooms with perfect symmetry and resilience, 
              Alium Software represents precision, beauty, and strength in technology solutions. 
              Our name may miss a letter, but our commitment to excellence never wavers.
            </p>
            <p className="about-description">
              We are a specialized consultancy firm with deep expertise in finance and healthcare 
              industries. Our team combines technical excellence with industry knowledge to deliver 
              solutions that not only meet today's challenges but anticipate tomorrow's opportunities.
            </p>
            
            <div className="about-stats">
              <div className="stat-item">
                <div className="stat-number">50+</div>
                <div className="stat-label">Projects Delivered</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">98%</div>
                <div className="stat-label">Client Satisfaction</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Support Available</div>
              </div>
            </div>
          </div>
          
          <div className="about-visual">
            <div className="expertise-list">
              <h3>Why Choose Us?</h3>
              <ul>
                <li>
                  <span className="check-icon">✓</span>
                  Industry-specific expertise in finance and healthcare
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Azure certified cloud architects and developers
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Agile development methodologies
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  DevOps and continuous delivery practices
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Regulatory compliance and security focus
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Ongoing support and maintenance
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;